<template>
  <div>
    <modal-poup-sala-de-disputa :modal="modalaviso_trt" :leilao="leilao"
                                :dados="dadosPopup" @fecharModalPopup="fecharPopup"/>

    <bread-crumb :categorialeilao="leilao.categorialeilao"
                 :nomeLeilao="leilao.nm"></bread-crumb>

    <div v-if="naoEncomtrado">
      <!-- MENSAGEM DE NÃO ENCONTRADO -->
      <nao-encontrado :leilaoId="leilao.id" :cookie="cookie" :leilaoNaoEncontrado="leilaoNaoEncontrado" :leilaoEncerrado="leilaoEncerrado"></nao-encontrado>
    </div>

    <div v-show="loadingPage == false && naoEncomtrado == false">
      <!-- LISTAGEM - SALA DE DISPUTA -->
      <div class="clearfix"></div>
      <header-disputa
        :leilaoid="leilaoId"
        :lotes="lotes"
        :dadosLeilao="dadosLeilao"
        :dadosLeilaoRealtime="leilao"
        :dadosHeader="dadosHeader"
        :loadingRefresh="loadingRefresh"
        :dadosModeradorId="dadosModeradorId">
      </header-disputa>
      <!-- CABEÇALHO LEILAO -->
      <div class="clearfix"></div>
      <span v-if="leilao.statusmontagem_id !== 6 && leilao.statusmontagem_id !== 8 && message !== ''">
        <mensagem-box
          v-show="mostrarMesagem && firstLoadSalaDisputa === false && loadingRefresh === false"
          :message="message"
          :liberado="liberado"
          :usuario="usuario">
        </mensagem-box>
      </span>

      <mensagem-box-leilao
        v-show="mostrarMesagem && firstLoadSalaDisputa === false && loadingRefresh === false"
        :message_informativo="message_informativo"
        :informativo="informativo">
      </mensagem-box-leilao>

      <div id="" ref="ancora"></div>
      <!-- ANCORA SCROLL -->
      <filtro
        :leilao="leilao"
        :filtros="filtros"
        :loadfiltro="loadfiltro"
        v-show="leilao && firstLoadSalaDisputa === false && loadingRefresh === false">
      </filtro>
      <br/>
      <!-- FILTROS -->
      <seguir-leiloeiro
        v-show="leilao && !leilao.bn_fechamentoautomatico && loadingRefresh === false"
        :firstLoadSalaDisputa="firstLoadSalaDisputa"
        :loadingRefresh="false"
        :lote_id_pregao="lote_id_pregao"
        :leilao="leilao"
        :seguir="seguir"
        tela="saladisputa"
        @seguirLeiloeiro="seguirLeiloeiro()">
      </seguir-leiloeiro>

      <span class="texto-apregoamento" v-show="seguir">
                O Leiloeiro está apregoando o bem abaixo nesse momento.
      </span>

      <div class="clearfix"></div>

      <ul id="grid" class="products-list" v-show="seguir">
        <li>
          <Item
            :leilao="leilao"
            :dados="lote_em_pregao"
            :liberado="liberado"
            :automatico="fechamento"
            :usuarioid="usuario.id"
            :status="leilao.nm_status"
            :exibirvideo="seguir" :embedTransmissao="dadosLeilao.nm_embedtransmissao" :tipoTransmissao="dadosLeilao.tp_transmissao">
          </Item>
        </li>
      </ul>
      <div class="clearfix"></div>
      <!-- BOTAO DE SEGUIR LEILOEIRO -->
      <div class="clearfix"></div>

      <!-- LOAD DE CONTEUDO -->
      <div class="pag-container-vu paginatio-mobile" style="clear:both;"
           v-show="firstLoadSalaDisputa === false && loadingRefresh === false">
        <paginate
          v-model="paginaAtual"
          :page-count="Number(paginator.pageCount)"
          :page-range="getWindowWidth() <= 700 ? 3 : 15"
          :margin-pages="getWindowWidth() <= 700 ? 2 : 4"
          :click-handler="clickCallback"
          :prev-text="'Anterior'"
          :next-text="'Próximo'"
          :container-class="'pagination'"
          :force-page="paginaAtual > 1 ? paginaAtual - 1 : 0"
          :page-class="'page-item'"
          :initial-page="0"
          ref="paginate1">
        </paginate>
        <div @click="refreshPage" class="refresh-btn fa fa-refresh" title="Atualizar todos os lotes"></div>
        <div class="open-listagem" v-show="leilao.statusleilao_id !== 17">
          <div v-if="usuarioLoaded">
            <router-link v-if="usuario && usuario.interesse && usuario.interesse.length > 0"
                         :to="'/leilao/index/leilao_id/'+leilaoId+'/meuslotes'"
                         title="Lotes favoritos">
              <span class="fa fa-heart"></span>
            </router-link>
          </div>
          <span class="open-carta"></span>
        </div>
        <div class="clearfix"></div>
      </div>
      <!-- PAGINAÇÃO TOPO -->
      <!-- CARDS LOTES -->
      <Stretch v-show="loadingRefresh">Carregando...</Stretch>

      <ul id="grid" class="products-grid columns4" v-if="loadingRefresh === false && isCartaActive === 'carta'">
        <li v-for="(lote, idx) in lotes" :key="idx" class="lote-item">
          <card
            :leilao="leilao"
            :dadosLeilao="dadosLeilao"
            :dados="lote"
            :liberado="liberado"
            :automatico="fechamento"
            :usuarioid="usuario.id"
            :intermediarios="intermediarios"
            :statusleilao_id="leilao.statusleilao_id"
            :countLances="countLances[idx]"
            :paramsite_proposta="paramsite_proposta"
            @refresh-dados-gerais="refreshDadosGerais">
          </card>
        </li>
      </ul>

      <!--MODO LISTA-->
      <ul id="grid" class="products-list" v-show="loadingRefresh == false && isCartaActive === 'lista'">
        <li v-for="(lote,idx) in lotes" :key="idx">
          <Item
            :leilao="leilao"
            :dados="lote"
            :liberado="liberado"
            :automatico="fechamento"
            :usuarioid="usuario.id"
            :status="leilao.nm_status"
            :exibirvideo="false">
          </Item>
        </li>
      </ul>

      <div class="pag-container-vu paginatio-mobile" style="clear:both;"
           v-show="firstLoadSalaDisputa === false && loadingRefresh === false">
        <paginate
          v-model="paginaAtual"
          name="paginacao"
          :page-count="Number(paginator.pageCount)"
          :page-range="getWindowWidth() <= 700 ? 3 : 15"
          :margin-pages="getWindowWidth() <= 700 ? 2 : 4"
          :click-handler="clickCallback"
          :prev-text="'Anterior'"
          :next-text="'Próximo'"
          :container-class="'pagination'"
          :force-page="paginaAtual > 1 ? paginaAtual - 1 : 0"
          :page-class="'page-item'"
          ref="paginate2">
        </paginate>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
// PLUGIN COMPONENTS
import Paginate from "vuejs-paginate";
import {Stretch} from "vue-loading-spinner";
import {Carousel, Slide} from "vue-carousel";

// LAYOUT COMPONENTS
import Card from "@/components/shared/Card";
import Item from "@/components/shared/Item";
import BreadCrumb from "@/components/shared/BreadCrumb";
// import BotoesRotas from "@/components/shared/BotoesRotas";
import NaoEncontrado from "@/components/shared/NaoEncontrado";
import HeaderDisputa from "@/components/shared/HeaderDisputa";
import MensagemBox from "@/components/shared/MensagemBox";
import MensagemBoxLeilao from "@/components/shared/MensagemBoxLeilao";
import Filtro from "@/components/shared/Filtro";
import SeguirLeiloeiro from "@/components/shared/SeguirLeiloeiro";
import ModalPoupSalaDeDisputa from "@/components/shared/modalPoupSalaDeDisputa.vue";

let interval = null;

export default {
  name: "SalaDisputa",
  props: ["dadosLeilao", "dadosModeradorId"],
  components: {
    ModalPoupSalaDeDisputa,
    BreadCrumb,
    Card,
    Item,
    Stretch,
    Paginate,
    Carousel,
    Slide,
    NaoEncontrado,
    HeaderDisputa,
    MensagemBox,
    MensagemBoxLeilao,
    SeguirLeiloeiro,
    Filtro
  },
  data() {
    return {
      dadosPopup: [],
      countLances: [],
      leilaoId: this.$route.params.id,
      lote_id_pregao: null,
      leilao: {},
      lotes: [],
      visitas: [],
      lotesAcompanhar: [],
      lotesPregao: [],
      config_leiloeiro: [],
      dados_condicao: [],
      usuario: {
        interesse: []
      },
      usuarioLoaded: false,
      paginator: {pageCount: 1, countLote: 0},
      filtros: [],
      errors: [],
      lotesStatusReference: [],
      lotesLanceReference: [],
      lotesIncrementoReference: [],
      lotesDtfechamentoReference: [],
      loteStatusReference: null,
      loteLanceReference: null,
      loteLanceLastReference: null,
      loteIncrementoReference: null,
      loteDtfechamentoReference: null,
      lotePregaoAtualReference: null,
      lotePregaoRequestKey: null,
      lotePregaoObservedKey: null,
      lotePregaoObservedVersion: 0,
      dadosRequisicao: {isLogado: false, countLote: 2},
      value_video: null,
      loadingPage: true,
      loadingRefresh: false,
      naoEncomtrado: false,
      leilaoNaoEncontrado: false,
      firstLoadSalaDisputa: true,
      paginaAtual: 0,
      seguir: false,
      message: "",
      liberado: false,
      fechamento: false,
      message_informativo: "",
      informativo: false,
      parametrosFiltro: "",
      refreshSalaDisputa: null,
      refreshCountSalaDisputa: 30000,
      cookie: true,
      logoEl: null,
      intermediariosRef: null,
      numeroRegistrosPorPagina: 44, // 44
      saladisputa: null,
      lote_em_pregao: 1,
      statusleilao_id: "",
      paramsite_proposta: [],
      intermediarios: null,
      modalaviso_trt: true,
      mostrarMesagem: false,
      statusModerador: null,
      loadfiltro: false,
      isCartaActive: 'carta',
      dadosHeader: []
    };
  },
  computed: {
    leilaoEncerrado() {
      return Boolean(this.dadosLeilao && [6, 8].includes(Number(this.dadosLeilao.statusmontagem_id)));
    },
  },
  watch: {
    'dadosModeradorId'(novo, ant) {
      const lotePregaoAnterior = this.lote_id_pregao
      const lotePregaoModeradorId = this.getStatusModeradorId(novo)

      this.statusModerador = lotePregaoModeradorId
      this.lote_id_pregao = lotePregaoModeradorId

      if (this.seguir && lotePregaoModeradorId && lotePregaoModeradorId !== lotePregaoAnterior) this.actionSeguir()
    }
  },

  methods: {
    getStatusModeradorId(dadosModerador) {
      if (dadosModerador && dadosModerador.items && dadosModerador.items[0]) {
        return dadosModerador.items[0].statuslotemoderador_id
      }

      return null
    },

    handleLogoClick(event) {
      event.preventDefault()

      sessionStorage.removeItem('filtrosLotes')
      sessionStorage.removeItem('loteId')

      Object.keys(sessionStorage).forEach(function (key) {
        if (key.startsWith('cacheFiltros:tipo')) {
          sessionStorage.removeItem(key)
        }
      })

      window.location.href = '/'
    },

    toggleFormat(format) {
      this.isCartaActive = format;
      this.callData()
    },

    fecharPopup(dados) {
      this.modalaviso_trt = dados;
    },

    actionSeguir() {
      // AÇÃO DE SEGUIR LEILOEIRO
      if (this.seguir) {
        // ordena seguindo lote em pregao
        this.saladisputa.ordenaLotesPorSeq(this.lotes);
        this.saladisputa.carregaLoteEmPregao(
          this.lote_id_pregao,
          this.leilaoId
        );
      } else {
        if (this.saladisputa && typeof this.saladisputa.limpaLotePregaoReference === 'function') {
          this.saladisputa.limpaLotePregaoReference()
        }
        this.saladisputa.ordenaLotesPorSeq(this.lotes);
      }
    },

    seguirLeiloeiro(ev) {
      this.seguir = !this.seguir;
      if (this.leilao && !this.leilao.bn_fechamentoautomatico) {
        const lotePregaoModeradorId = this.statusModerador || this.lote_id_pregao

        if (this.seguir || lotePregaoModeradorId > 0) {
          this.lote_id_pregao = (lotePregaoModeradorId > 0)
            ? lotePregaoModeradorId : (this.lotes[0] ? this.lotes[0].lote_id : null);

          if (this.lote_id_pregao) {
            this.actionSeguir();
          }
        }
      }
    },

    stopLoading() {
      this.loadingPage = false;
      this.loadingRefresh = false;
      this.firstLoadSalaDisputa = false;
    },

    callData(stopLoading = true) {
      this.loadingPage = true;
      this.loadingRefresh = true;
      if (this.$route.query.page) {
        this.paginaAtual = parseInt(this.$route.query.page);
      } else {
        this.paginaAtual = 0;
      }

      this.saladisputa.paginaAtual = this.paginaAtual;
      this.refreshDadosGerais();

      if (stopLoading) {
        this.stopLoading()
      }
    },

    clickCallback(pageNum) {
      this.loadingRefresh = true;

      const newRoute = {
        path: `/leilao/index/leilao_id/${this.leilaoId}`,
        query: {page: pageNum}
      };

      const newRouteList = {
        path: `/leilao/index/listagem/leilao_id/${this.leilaoId}`,
        query: {page: pageNum}
      };

      const isDifferentRoute = (
        this.$route.fullPath !== this.$router.resolve(newRoute).href &&
        this.$route.fullPath !== this.$router.resolve(newRouteList).href
      );

      if (isDifferentRoute) {
        this.paginaAtual = pageNum;
        this.$router.push({query: {page: pageNum}});
        this.saladisputa.refreshLotesListagem();
        this.$forceUpdate();
        this.$refs.ancora.scrollIntoView({behavior: "smooth"});
      }

      this.loadingRefresh = false;
    },

    refreshPage(ev) {
      this.loadingRefresh = true;
      this.callData(false);
      this.saladisputa.refreshLotesListagem();
      this.stopLoading();
    },

    refreshDadosGerais(_self) {
      const hostName = location.protocol + "//" + window.HOSTNAME;
      var self = this;

      fetch(`${hostName}/leilao/get-dados-gerais?leilao_id=${this.leilaoId}`)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then(res => {
          self.usuario = res.usuario;
          self.visitas = res.visitas;
          self.usuarioLoaded = true;
          self.interesse = res.usuario.interesse || [];

          self.dadosRequisicao.isLogado = self.usuario.id !== null;
          self.saladisputa.configuraFavoritos(_self);
          self.saladisputa.configuraVisitas();

          if (self.usuario.interesse && self.usuario.interesse.length > 0) {
            self.$emit('update-interesse', self.usuario.interesse);
          }
        });
    },

    getDadosPopup() {
      const hostName = location.protocol + "//" + window.HOSTNAME;
      var self = this;

      fetch(`${hostName}/core/api/get-dados-site-popup`)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then(res => {
          res.popups.filter((popup) => {
            if (!popup.bn_mostrar_em && popup.leilao_id === parseInt(self.leilaoId))
              self.dadosPopup = popup;
          })
        });
    },

    getWindowWidth() {
      return window.innerWidth;
    },

    getIntermediarios() {
      if (this.usuario.id !== undefined) {
        const self = this;
        if (this.intermediariosRef) {
          this.intermediariosRef.off()
        }

        this.intermediariosRef = this.firebase_db.ref(`/intermediarios/${self.usuario.id}`)
        this.intermediariosRef.on('value', function (
          usuario_intermediario
        ) {
          self.intermediarios = usuario_intermediario.val()
        })
      }
    },
  },
  beforeCreate() {
    this.$on("liberacaoMensagem", function (json) {
      this.message = json.message;
      this.liberado = json.liberado;
      this.fechamento = json.fechamento;
      this.message_informativo = json.message_informativo;
      this.informativo = json.informativo;
      this.mostrarMesagem = json.mostrarMesagem
    });
  },
  async created() {
    this.$vs.loading({background: "#fff", color: "#67302B"});
    this.getDadosPopup();

    this.statusModerador = this.getStatusModeradorId(this.dadosModeradorId)

    clearInterval(window.INTERVALO_BUSCA);
    clearInterval(window.INTERVALO_CATEGORIA);

    this.saladisputa = new window.saladisputa(this);
    const leilaoEncontrado = await this.saladisputa.registraLotePregao();

    if (!leilaoEncontrado) {
      this.leilaoNaoEncontrado = true;
      this.naoEncomtrado = true;
      this.cookie = this.$root.cookieAtivo;
      this.stopLoading();
      this.$vs.loading.close();
      return;
    }

    await this.callData(false);

    if (this.leilao.categorialeilao.length > 1) {
      await this.saladisputa.filtrarAction();
    } else {
      this.loadfiltro = true;
    }

    //Finaliza loading
    this.stopLoading();

    this.$on("filtroChange", async function (dadosFiltro) {
      let parametros = "";
      this.loadingRefresh = true;
      if (dadosFiltro.filtro1 !== "") {
        parametros += `segmento_id=${dadosFiltro.filtro1}`;
      } else {
        parametros = "";
      }

      if (dadosFiltro.filtro2 !== "") {
        parametros += `&filtro1=${dadosFiltro.filtro2}`;
      }
      if (dadosFiltro.filtro3 !== "") {
        parametros += `&filtro2=${dadosFiltro.filtro3}`;
      }
      if (dadosFiltro.filtro4 !== "") {
        parametros += `&filtro3=${dadosFiltro.filtro4}`;
      }
      if (dadosFiltro.filtro5 !== "") {
        parametros += `&filtro4=${dadosFiltro.filtro5}`;
      }
      this.parametrosFiltro = parametros;

      await this.saladisputa.filtrarAction();
      this.loadingRefresh = false;
    });

    this.$on("dados-gerais", function (data) {
      this.config_leiloeiro = data.config_leiloeiro;
      this.dados_condicao = data.dados_condicao;
      this.usuario = data.usuario;
      this.dadosRequisicao.leilaoId = this.leilao.id;
      this.dadosRequisicao.isLogado = this.usuario.id !== null;
      this.visitas = data.visitas;

      this.saladisputa.configuraFavoritos();
      this.saladisputa.configuraVisitas();
      this.getIntermediarios();

      this.$vs.loading.close();
      this.loadfiltro = true;
    });

    this.$on("favoritoModificado", function (_self) {
      this.refreshDadosGerais(_self);
    });

    this.$on("loteIdAtualChange", function (id) {
      this.dadosRequisicao.loteId = id !== null ? id : this.lotes[0].lote_id;
      sessionStorage.setItem("loteId", id);
    });

    this.cookie = this.$root.cookieAtivo;
    this.$root.MensagemBrowserCookie();

    const self = this;
    var db = this.firebase_db;

    db.ref(`/paramsite/`).once("value", function (data) {
      $.each(data.val(), function (key, value) {
        if (value && value.statusparamsite_id === 74) {
          self.paramsite_proposta = value;
        }
      });
    });
  },
  mounted() {
    this.logoEl = document.querySelector('img[alt="Logo"]')
    if (this.logoEl) {
      this.logoEl.addEventListener('click', this.handleLogoClick)
    } else {
      console.warn('Logo não encontrado no DOM')
    }
  },
  beforeDestroy() {
    if (this.logoEl) {
      this.logoEl.removeEventListener('click', this.handleLogoClick)
      this.logoEl = null
    }

    if (this.intermediariosRef) {
      this.intermediariosRef.off()
      this.intermediariosRef = null
    }

    this.$off('favoritoModificado')
    this.$off('loteIdAtualChange')

    if (this.saladisputa) {
      if (typeof this.saladisputa.limpaLotesReference === 'function') {
        this.saladisputa.limpaLotesReference()
      }

      if (typeof this.saladisputa.limpaLotePregaoReference === 'function') {
        this.saladisputa.limpaLotePregaoReference()
      }

      if (typeof this.saladisputa.limpaLotePregaoAtualReference === 'function') {
        this.saladisputa.limpaLotePregaoAtualReference()
      }
    }
  }
}
</script>

<style>
/* EFEITO DE TRANSIÇÃO*/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ESTILOS GERAIS */
.refresh-btn {
  cursor: pointer;
  float: right;
  margin-right: 0;
  line-height: 28px;
  font-size: 20px;
  transform: translateY(-5px);
  color: #67302b;
}

.open-listagem {
  float: right;
  margin-top: -5px;
  margin-right: 7px;
  line-height: 31px;
  font-size: 20px;
  color: #67302b;
  display: flex;
  gap: 10px;
}

.doc-icons {
  cursor: pointer;
  text-align: center;
}

.dialog-content {
  max-height: 400px;
  overflow: auto;
}

.boxRegulamento {
  padding: 0px !important;
}

.container-box {
  height: auto !important;
  width: 100% !important;
  overflow: inherit !important;
}

#portotemplate .spinner {
  margin: 0 auto;
  display: block;
  margin-top: 30px;
  margin-bottom: 200px;
}

#portotemplate .spinner div {
  background-color: #67302b !important;
}

#portotemplate a:hover,
#portotemplate a:focus {
  text-decoration: none;
}

.VueCarousel-navigation a.VueCarousel-navigation-prev {
  left: 24px !important;
  background: #fff;
  border-radius: 2px;
}

.VueCarousel-navigation a.VueCarousel-navigation-next {
  right: 24px !important;
  border-radius: 2px;
  background: #fff;
}

.VueCarousel-navigation a.VueCarousel-navigation--disabled {
  display: none;
}

.pag-container-vu {
  width: 98%;
  margin: 20px auto;
  text-align: center;
}

#portotemplate .pagination > li:first-child > a,
#portotemplate .pagination > li:last-child > a,
#portotemplate .pagination > li:last-child > span {
  padding: 2px 5px;
}

#portotemplate .li-hidden {
  display: none;
}

.open-listagem .ativo {
  color: #46a04c !important;
}

@media (max-width: 600px) {
  .pagination {
    margin-top: 60px !important;
    margin-bottom: -8px !important;
  }
}

@media (max-width: 500px) {
  #switch_seguir {
    margin-top: -5px;
  }

  .paginatio-mobile {
    margin-top: 17px;
  }
}

.texto-apregoamento {
  color: #444249;
  font-weight: bold;
  display: flex;
  font-size: 1.4em;
  justify-content: center;
  flex-direction: row-reverse;
  border-bottom: 3px solid #67302C;
  position: relative;
  width: 565px;
  right: -50%;
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-left: 1px solid #ccc;
  padding: 5px;
  border-radius: 3px;
}

@media (max-width: 1199px) {
  .texto-apregoamento {
    width: 467px;
    font-size: 1.23em;
  }
}

@media (max-width: 991px) {
  .texto-apregoamento {
    width: 358px;
    font-size: 12px;
  }

  .corpo_TRT {
    margin: 0 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/SalaDisputa.vue